$(function () {

    // Add class if edge
    if (/Edge/.test(navigator.userAgent)) {
        $('body').addClass('ie ie--edge');
    }

    // Add class if IE 11
    var is_ie11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    if (is_ie11) {
        $('body').addClass('ie ie--11');
    }

    // Add class if IE10
    var is_ie10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    if (is_ie10) {
        $('body').addClass('ie ie--10');
    }

    // Add class if safari
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (is_safari) {
        $('body').addClass('body--safari');
    }

    objectFitPolyfill();


    /* ==== init ==== */
    // if (!is_ie11) {
    //     var images = document.querySelectorAll('.project-image__img, .content-img');
    //     new simpleParallax(images);
    // }

    $('.lazy-load').Lazy({
        effect: 'fadeIn',
        effectTime: 300
    });

    $('.grid--top').flowtype({
        minimum: 769,
        maximum: 1200,
        maxFont: 16,
        fontRatio: 80
    });



    /* ==== Mobile navigation ==== */
    menu_trigger = $('.menu-trigger');
    nav = $('nav');

    menu_trigger.click(function () {
        $(this).toggleClass('menu-trigger--active');
        nav.toggleClass('nav--active');
    });

    $(document).click(function (e) {
        if (!menu_trigger.is(e.target)) {
            menu_trigger.removeClass('menu-trigger--active');
            nav.removeClass('nav--active');
        }
    });

    nav.click(function (event) {
        event.stopPropagation();
    });


    /* === Navigation dropdown === */
    $('.nav__link').filter(function() {
        return ($(this).siblings('.nav__list--dropdown').length !== 0)
    }).after('<span class="nav__dropdown-toggle">></span>');

    $('.nav__dropdown-toggle').on('click', function(){
        $(this).toggleClass('nav__dropdown-toggle--active');
        $(this).nextAll('.nav__list--dropdown').toggleClass('nav__list--dropdown--active');
    });

    // if ($('.nav__item').find('.nav__list--dropdown').length !== 0) {
    //     $('.nav__item').after('<span class="nav__dropdown-toggle"></span>')
    // };

    // $('.nav__item').click(function(e){
    //     if ($(this).find('.nav__list--dropdown').length !== 0) {
    //         e.preventDefault();
    //         $('.nav__list--dropdown').toggleClass('nav__list--dropdown--active');
    //     }
    // });


    /* ==== Listing tags ==== */
    $('.listing-header__filter').click(function(){
        $('.listing-header__filter').removeClass('listing-header__filter--active');
        $(this).toggleClass('listing-header__filter--active');
    });


    /* === textarea expand === */
    // Applied globally on all textareas with the "autoExpand" class
    $(document)
        .one('focus.autoExpand', 'textarea.autoExpand', function(){
            var savedValue = this.value;
            this.value = '';
            this.baseScrollHeight = this.scrollHeight;
            this.value = savedValue;
        })
        .on('input.autoExpand', 'textarea.autoExpand', function(){
            var minRows = this.getAttribute('data-min-rows')|0, rows;
            this.rows = minRows;
            rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 16);
            this.rows = minRows + rows;
        });



    /* ==== Cookie notice ==== */
    var cookie = $('.cookie-notice');

    if (Cookies.get('CCcookie')) {
        cookie.hide();
    } else {
        cookie.show();
        $('.cookie-notice__close').click(function () {
            Cookies.set('CCcookie', 'accepted', {
                expires: 365
            });
            cookie.hide();
        });
    }



});




$(window).on('load', function () {
    // Remove loading window
    setTimeout(function () {
        $('.loading-overlay').addClass('loading-overlay--hide');
        $('.homepage').addClass('homepage--active');
        $('main').addClass('main--active');
    }, 500);
});

console.log = function() {}



